import { PriceManagerDatapointsModel } from '../../hooks/usePriceManagerDatapointsModel';
import { getTotalPrices, initialTotalPricesData } from '../../services';

export const totalPriceQuery = (priceManagerDatapointsModel?: PriceManagerDatapointsModel) => {
  return {
    queryKey: ['totalPrices', priceManagerDatapointsModel],
    queryFn: () => getTotalPrices(priceManagerDatapointsModel),
    initialData: initialTotalPricesData,
  };
};
